// HeroCarousel.jsx
import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { motion } from 'framer-motion';
import "swiper/css";
import "swiper/css/autoplay";
import "./Carousal.css";
import { useLocation,useNavigate } from 'react-router-dom';

const HeroCarousel = () => {
    const slides = [
        {
            title: "MAINTENANCE & REPAIR SERVICE",
            description:
                "Promotors is one of the leading units specializing in providing car care equipment and tools worldwide. Need to buy car care tools, accessories, this will be a useful choice.",
            button: "GET OFFERS",
            image: "/assets/Carousel/home1-bg-01.png",
            image2: "/assets/Carousel/hover5.jpg"
        },
        {
            title: "MAINTENANCE & REPAIR SERVICESDAd",
            description:
                "Promotors is one of the leading units specializing in providing car care equipment and tools worldwide. Need to buy car care tools, accessories, this will be a useful choice.",
            button: "GET OFFERS",
            image: "/assets/Carousel/home1-bg-01.png",
            // image2: "/assets/Carousel/hover5.jpg"
        },
        {
            title: "MAINTENANCE & REPAIR SERVICE",
            description:
                "Promotors is one of the leading units specializing in providing car care equipment and tools worldwide. Need to buy car care tools, accessories, this will be a useful choice.",
            button: "GET OFFERS",
            image: "/assets/Carousel/home1-bg-01.png",
            image2: "/assets/Carousel/hover5.jpg"
        },
        {
            title: "MAINTENANCE & REPAIR SERVICE",
            description:
                "Promotors is one of the leading units specializing in providing car care equipment and tools worldwide. Need to buy car care tools, accessories, this will be a useful choice.",
            button: "GET OFFERS",
            image: "/assets/Carousel/home1-bg-01.png",
            image2: "/assets/Carousel/hover5.jpg"
        },
    ];
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null)
       const navigate = useNavigate();
        const handleScroll = (event, id) => {
            event.preventDefault();
            const currentPath = window.location.pathname;
            if (currentPath !== '/') {
              navigate('/', { state: { scrollTo: id } });
            } else {
              const section = document.getElementById(id);
              if (section) {
                const yOffset = -210;
                const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }
          };
    useEffect(() => {
        // Replace with your API endpoint
        const fetchData = async () => {
            try {
                const response = await fetch('https://admin.ezerautomotive.co.nz/api/banners/');
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const result = await response.json();
                setData(result);
                console.log(result, "bannerresult")
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const [hovered, setHovered] = useState(false);
    const fadeInFromRight = {
        hidden: { opacity: 0, x: 100 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                type: 'spring',
                bounce: 0.3,
                duration: 1,
            },
        },
    };
    const fadeIn = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                duration: 1,
                ease: 'easeOut',
            },
        },
    };
    const bounceFromRight = {
        hidden: { opacity: 0, x: 100 },
        visible: {
            opacity: 1,
            x: 0,
            transition: {
                type: 'spring',
                bounce: 0.7,
                duration: 1.2,
                stiffness: 50,
                damping: 5,
            },
        },
    };

    return (
        <div>
            <Swiper
                modules={[Autoplay]}
                autoplay={{ delay: 7000 }}
                loop={true}
                // autoplay={false}
                className="hero-swiper"
            >
                {data.map((slide, index) => (
                    <SwiperSlide key={index}>
                        <div className="hero-slide">
                            <video autoPlay loop muted className="background-video" playsInline style={{ filter: "contrast(1.2) brightness(0.2)" }}>
                                <source src="/assets/video/BG.mp4" type="video/mp4" />
                            </video>
                            <motion.div
                                className="background-title chakra-petch-semibold"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true, amount: 0.5 }}
                                variants={bounceFromRight}
                            >
                                EZER
                            </motion.div>
                            <div
                                className="hero-text"
                            // initial="hidden"
                            // whileInView="visible"
                            // viewport={{ once: true, amount: 0.5 }}
                            // variants={fadeInFromRight}
                            >
                                <motion.h1 className="chakra-petch-semibold"
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.5 }}
                                    variants={fadeInFromRight}
                                >
                                    {slide.title}
                                </motion.h1>
                                <motion.p
                                    className="font-mulish"
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.5 }}
                                    variants={fadeInFromRight}
                                    transition={{ delay: 0.3 }}
                                >
                                    {slide.description}
                                </motion.p>
                                <motion.div
                                    style={{ width: '100%' }}
                                    initial="hidden"
                                    whileInView="visible"
                                    viewport={{ once: true, amount: 0.5 }}
                                    variants={fadeInFromRight}
                                    transition={{ delay: 0.5 }}
                                > <button className="hero-btn"  onClick={(event) => handleScroll(event, 'contact')}>GET OFFERS</button>
                                </motion.div>

                            </div>
                            <motion.div className="hero-img"
                                animate={{ y: [0, -15, 0] }}
                                transition={{
                                    duration: 3,
                                    repeat: Infinity,
                                    ease: "easeInOut"
                                }}
                            >
                                <div className="left-light">
                                    <img src='/assets/Carousel/left.png' />
                                </div>
                                <div>
                                    <img src='/assets/Carousel/home1-bg-01.png' className="car" alt="car engine" />
                                </div>
                                <div className="rotate">
                                    <img src='/assets/Carousel/rotate.png' />
                                </div>

                                <div className="right-light">
                                    <img src='/assets/Carousel/right.png' />
                                </div>
                            </motion.div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};

export default HeroCarousel;
